import React, {Component} from "react";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
  Radio,
  InputGroup,
  Grid,
  Row,
  Col,
  Popover,
  OverlayTrigger,
  Button,
  Modal,
  Table,
  Alert
}                         from "react-bootstrap";
import Select             from "react-select";
import                          "react-select/dist/react-select.css";
import Dropzone           from "react-dropzone";
import moment             from "moment";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import cloneDeep          from "lodash.clonedeep";
import debounce           from "lodash.debounce";
import Pagination         from "react-js-pagination";
import {
  toast
}                           from "react-toastify";
import {
  IS_VALID,
  IS_NULL
}                         from "utils";

import { EVOUCHER }       from "actions/const";

import Loader             from "../../Loader.js";
import ic_add_image       from "../../../assets/image/ic_add_image.svg";
import style from "../style.less";

export default class Create extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoadingRelation: false,

      showModalCategory: false
    };

    this.dropzoneRef;

    this.campaignCategoryComponentRef;

    this.getRelation = this.getRelation.bind(this);
  }

  getRelation () {
    let {
      actions,
      EVoucher,
      getRelation
    } = this.props;

    let {
      formType,
      selectedData
    } = EVoucher;

    if (IS_VALID(selectedData) && (formType.toUpperCase() === "UPDATE" || formType.toUpperCase() === "DUPLICATE")) {

      this.setState({ isLoadingRelation: true });

      getRelation()
      .then(([ transactionType, sendPushNotification, cardType, specificUser, blacklistedUser, evScannerUser ]) => {
        let transactionTypeArray = transactionType.map((item) => ({
          label: item.get("name"),
          value: item.id
        }));

        let sendPushNotificationArray = sendPushNotification.map((item) => ({
          label: item.get("name"),
          value: item.id
        }));

        let cardTypeArray = cardType.map((item) => ({
          label: item.get("name"),
          value: item.id
        }));

        let specificUserArray = specificUser.map((item) => ({
          label: `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`,
          value: item.id
        }));

        let blacklistedUserArray = blacklistedUser.map((item) => ({
          label: `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`,
          value: item.id
        }));

        let evScannerUserArray = evScannerUser.map((item) => ({
          label: item.get("name"),
          value: item.id
        }));

        this.setState({ isLoadingRelation: false });

        actions.setValue(
          EVOUCHER,
          {
            transactionType: transactionTypeArray,
            sendPushNotification: sendPushNotificationArray,
            cardType: cardTypeArray,
            specificUser: specificUserArray,
            blacklistedUser: blacklistedUserArray,
            evScannerUser: evScannerUserArray
          }
        );
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({ isLoadingRelation: false });
      });
    }
  }
  
  render () {
    let {
      isLoadingRelation,

      showModalCategory
    } = this.state;

    let {
      loadOptions,
      actions,
      EVoucher,
      uploadSpecificUserCSVFile
    } = this.props;

    let {
      isLoadingAction,
      formType,
      selectedData,

      isUploadingCSVFile,
      isUploadingCSVFileBlacklistedUser,
      isUploadingCSVFileEVScannerUser,

      typeK,
      transactionType,
      cardType,
      pointType,
      deductPointType,
      birthMonth,
      birthMonthOptions,
      tdd_birthMonthStartDate,
      tdd_birthMonthEndDate,
      campaignStartDate,
      campaignEndDate,
      specificUser,
      requiredEarningAmount,
      deductPointAmount,
      maxVoucherQuantity,
      maxVoucherQuantityPerDay,
      maxVoucherQuantityPerUser,
      maxVoucherQuantityPerUserPerDay,
      welcomeDays,
      version,
      campaignCategory,
      title,
      promotionName,
      descriptions,
      whereToRedeem,
      evScannerUser,
      manualDispense,
      serialNumberPrefix,
      amount,
      promoOwnerCostCenter,
      promoCategory,
      nnsl_amount,
      nnc_amount,
      image,
      isShowForFirstTimeUsers,
      isShowRemainingQuantity,
      isRateRequired,
      isShowMerchantsOwnRedemptionOnly,

      sendPushNotification,
      earningPeriod,
      earningPeriodStartDate,
      earningPeriodEndDate,

      voucherValidityType,
      voucherValidityDays,
      voucherValidityHour,
      voucherValidityMinute,
      voucherValiditySecond,
      voucherValidityStartDate,
      voucherValidityEndDate,
      voucherValidityStartTime,
      voucherValidityEndTime,
      voucherValidityIsUseCalendarDay,

      rateTimeConfigHour,
      rateTimeConfigMinute,
      rateTimeConfigSecond,

      blacklistedUser,

      gender,
      genderOptions,

      isCheckingEVoucherStatus
    } = EVoucher;

    let isEVoucherPublished = formType !== "DUPLICATE" &&
                              IS_VALID(selectedData) &&
                              IS_VALID(selectedData.get("status")) &&
                              (selectedData.get("status") === "PUBLISH" || selectedData.get("status") === "EXPIRED" || selectedData.get("status") === "SUSPENDED") &&
                              (IS_VALID(selectedData.get("campaignStartDate")) ? true : false) &&
                              (IS_VALID(selectedData.get("campaignStartDate")) && moment(selectedData.get("campaignStartDate")).isSameOrBefore(moment()));

    let totalCampaignDays = 0;

    if (
      IS_VALID(campaignStartDate) &&
      moment(campaignStartDate).isValid() &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate).isValid()
    ) {
      let totalDays = moment(moment(campaignEndDate).startOf("day")).diff(moment(campaignStartDate).startOf("day"), "days") + 1;

      if (totalDays >= 0) {
        totalCampaignDays = totalDays;
      }
    }

    const space = {
			paddingTop: '10px',
			paddingBottom: '10px'
		};

    let imageSrc = ic_add_image,
        imageStyle = {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 'auto',
          width: '100px',
          height: '100%'
        },
        dropZoneStyle = {
          display: "inline-block",
          verticalAlign: "top"
        },
        isHideX = {
          display: 'none'
        };

    if (IS_VALID(image)) {
      imageSrc = image.preview;
      imageStyle = {
        ...imageStyle,
        width: '',
        maxWidth: '100%',
        maxHeight: '100%'
      };
      dropZoneStyle = {
        verticalAlign: "middle"
      };
      isHideX = {};
    }

    let requiredSpan = <span style={{ color: "red" }}>*</span>;
    let loadingComponent = (
      <div style={{ textAlign: "center" }}>
        <i className="fa fa-spinner fa-spin"></i>
      </div>
    );
    let popupMessage = (component, message) => {
      return (
        <OverlayTrigger
          placement="top"
          id={message}
          overlay={
            <Popover>
              {message}
            </Popover>
          }
          >
          {component}
        </OverlayTrigger>
      );
    };

    let isCardTypeFieldDisabled = specificUser.length !== 0 ? true : false,
        isSpecificUserFieldDisabled = cardType.length !== 0 ? true : false;

    let getTotalVoucherValidity = (
      hour,
      minute,
      second
    ) => {
      let totalDays = 0,
          totalHours = 0,
          totalMinutes = 0,
          totalSeconds = 0;

      if (IS_VALID(hour) && parseFloat(hour) % 1 !== 0) {
        return {
          error: true,
          message: "Hour should be a whole number."
        };
      } else if (IS_VALID(hour) && parseInt(hour) > 0) {
        totalDays = Math.floor(hour/24);

        totalHours = parseInt(hour)-(totalDays*24);
      }

      if (IS_VALID(minute) && parseFloat(minute) % 1 !== 0) {
        return {
          error: true,
          message: "Minute should be a whole number."
        };
      } else if (IS_VALID(minute) && parseInt(minute) > 0) {
        let additionalHours = Math.floor(minute/60);

        if (additionalHours > 0) {
          totalHours += additionalHours;
        }

        totalMinutes = parseInt(minute)-(additionalHours*60);
      }

      if (IS_VALID(second) && parseFloat(second) % 1 !== 0) {
        return {
          error: true,
          message: "Second should be a whole number."
        };
      } else if (IS_VALID(second) && parseInt(second) > 0) {
        let additionalMinutes = Math.floor(second/60);

        if (additionalMinutes > 0) {
          totalMinutes += additionalMinutes;
        }

        totalSeconds = parseInt(second)-(additionalMinutes*60);
      }

      return {
        error: false,
        message: `${totalDays} day ${totalHours} hour ${totalMinutes} minute ${totalSeconds} second`
      };
    };

    let getTotalVoucherValidityResult = getTotalVoucherValidity(voucherValidityHour, voucherValidityMinute, voucherValiditySecond);

    let getTotalRateConfigTimeResult = getTotalVoucherValidity(rateTimeConfigHour, rateTimeConfigMinute, rateTimeConfigSecond);

    let isVoucherValidityType = (shortName = "") => (
      IS_VALID(voucherValidityType) &&
      IS_VALID(voucherValidityType.shortName) &&
      voucherValidityType.shortName === shortName
    );

    const checkVoucherType = (shortName) => IS_VALID(typeK) && IS_VALID(typeK.shortName) && typeK.shortName.toUpperCase() === shortName;

    let isWelcomeVoucher = checkVoucherType("W"),
        isBirthdayVoucher = checkVoucherType("B");

    return (
      <form>
        <Loader loading={isLoadingAction || isCheckingEVoucherStatus}/>
        <Row>
          <Col md={6}>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Type K {requiredSpan}</ControlLabel>
              </Col>
              <Col md={7}>
                <Select.Async
                  disabled={isEVoucherPublished}
                  placeholder="Select or Search..."
                  loadOptions={(input, cb) => loadOptions(input, cb, "VoucherType", "name")}
                  value={typeK}
                  onChange={(value) => {
                    if (!isEVoucherPublished) {
                      let stateToUpdate = {
                        typeK: value
                      };

                      if (
                        !IS_VALID(value) ||
                        (IS_VALID(value) && IS_VALID(value.shortName) && value.shortName.toUpperCase() !== "W")
                      ) {
                        stateToUpdate.welcomeDays = "";
                        stateToUpdate.isShowForFirstTimeUsers = false;
                      }

                      if (
                        !IS_VALID(value) ||
                        (IS_VALID(value) && IS_VALID(value.shortName) && value.shortName.toUpperCase() !== "B")
                      ) {
                        stateToUpdate.birthMonth = null;

                        if (!isEVoucherPublished) {
                          stateToUpdate.tdd_birthMonthStartDate = "";
                          stateToUpdate.tdd_birthMonthEndDate = "";
                        }
                      }

                      if (
                        IS_VALID(value) &&
                        IS_VALID(value.shortName) &&
                        value.shortName.toUpperCase() === "B"
                      ) {
                        stateToUpdate.voucherValidityType = null;
                        stateToUpdate.voucherValidityDays = "";
                        stateToUpdate.voucherValidityHour = "";
                        stateToUpdate.voucherValidityMinute = "";
                        stateToUpdate.voucherValiditySecond = "";
                        stateToUpdate.voucherValidityStartDate = "";
                        stateToUpdate.voucherValidityEndDate = "";
                        stateToUpdate.voucherValidityStartTime = "";
                        stateToUpdate.voucherValidityEndTime = "";
                        stateToUpdate.voucherValidityIsUseCalendarDay = false;
                      }

                      actions.setValue(EVOUCHER, stateToUpdate);
                    }
                  }}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Transaction Type</ControlLabel>
              </Col>
              <Col md={7}>
                {isLoadingRelation ? (
                  loadingComponent
                ) : (
                  <Select.Async
                    multi={true}
                    placeholder="Select or Search..."
                    loadOptions={(input, cb) => loadOptions(input, cb, "VoucherTransactionType", "name")}
                    value={transactionType}
                    onChange={(value) => actions.setValue(EVOUCHER, { transactionType: value })}/>
                )}
              </Col>
            </Row>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Point Type</ControlLabel>
              </Col>
              <Col md={7}>
                <Select.Async
                  placeholder="Select or Search..."
                  loadOptions={(input, cb) => loadOptions(input, cb, "VoucherPointType", "name")}
                  value={pointType}
                  onChange={(value) => {
                    let stateToUpdate = {
                      pointType: value
                    };

                    if (!IS_VALID(value)) {
                      stateToUpdate.requiredEarningAmount = "";
                    }

                    actions.setValue(EVOUCHER, stateToUpdate);
                  }}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Deduct Point Type</ControlLabel>
              </Col>
              <Col md={7}>
                <Select.Async
                  placeholder="Select or Search..."
                  loadOptions={(input, cb) => loadOptions(input, cb, "VoucherPointType", "name")}
                  value={deductPointType}
                  onChange={(value) => {
                    let stateToUpdate = {
                      deductPointType: value
                    };

                    if (!IS_VALID(value)) {
                      stateToUpdate.deductPointAmount = "";
                    }

                    actions.setValue(EVOUCHER, stateToUpdate);
                  }}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>
                  Card Type&nbsp;
                  {isCardTypeFieldDisabled ? (
                    popupMessage(
                      <i className="fa fa-info-circle"></i>,
                      "Specific User is already assigned."
                    )
                  ) : (
                    ""
                  )}
                </ControlLabel>
              </Col>
              <Col md={7}>
                {isLoadingRelation ? (
                  loadingComponent
                ) : (
                  <Select.Async
                    multi={true}
                    disabled={isCardTypeFieldDisabled}
                    placeholder="Select or Search..."
                    loadOptions={(input, cb) => loadOptions(input, cb, "VoucherCardType", "name")}
                    value={cardType}
                    onChange={(value) => actions.setValue(EVOUCHER, { cardType: value })}
                    />
                )}
              </Col>
            </Row>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Send Push Notification</ControlLabel>
              </Col>
              <Col md={7}>
                {isLoadingRelation ? (
                  loadingComponent
                ) : (
                  <Select.Async
                    multi={true}
                    placeholder="Select or Search..."
                    loadOptions={(input, cb) => loadOptions(input, cb, "VoucherNotificationPercentage", "name", "count")}
                    value={sendPushNotification}
                    onChange={(value) => actions.setValue(EVOUCHER, { sendPushNotification: value })}/>
                )}
              </Col>
            </Row>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Gender</ControlLabel>
              </Col>
              <Col md={7}>
                <Select
                  clearable={false}
                  placeholder="Select gender"
                  options={genderOptions}
                  value={gender}
                  onChange={(value) => actions.setValue(EVOUCHER, { gender: value })}
                  />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row style={space}>
              <Col md={8}>
                <ControlLabel>Requried Earning Amount {IS_NULL(pointType) ? "" : requiredSpan}</ControlLabel>
              </Col>
              <Col md={4}>
                <FormControl
                  type="number"
                  disabled={IS_NULL(pointType)}
                  value={requiredEarningAmount}
                  onChange={(e) => actions.setValue(EVOUCHER, { requiredEarningAmount: e.target.value })}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={8}>
                <ControlLabel>Deduct Amout {IS_NULL(deductPointType) ? "" : requiredSpan}</ControlLabel>
              </Col>
              <Col md={4}>
                <FormControl
                  type="number"
                  disabled={IS_NULL(deductPointType)}
                  value={deductPointAmount}
                  onChange={(e) => actions.setValue(EVOUCHER, { deductPointAmount: e.target.value })}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={8}>
                <ControlLabel>Max Voucher Quantity {requiredSpan}</ControlLabel>
              </Col>
              <Col md={4}>
                <FormControl
                  type="number"
                  value={maxVoucherQuantity}
                  onChange={(e) => actions.setValue(EVOUCHER, { maxVoucherQuantity: e.target.value })}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={8}>
                <ControlLabel>Max Voucher Quantity Per Day {requiredSpan}</ControlLabel>
              </Col>
              <Col md={4}>
                <FormControl
                  type="number"
                  value={maxVoucherQuantityPerDay}
                  onChange={(e) => actions.setValue(EVOUCHER, { maxVoucherQuantityPerDay: e.target.value })}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={8}>
                <ControlLabel>Max Voucher Quantity Per User {requiredSpan}</ControlLabel>
              </Col>
              <Col md={4}>
                <FormControl
                  type="number"
                  value={maxVoucherQuantityPerUser}
                  onChange={(e) => actions.setValue(EVOUCHER, { maxVoucherQuantityPerUser: e.target.value })}/>
              </Col>
            </Row>
            <Row style={space}>
              <Col md={8}>
                <ControlLabel>Max Voucher Quantity Per User Per Day {requiredSpan}</ControlLabel>
              </Col>
              <Col md={4}>
                <FormControl
                  type="number"
                  value={maxVoucherQuantityPerUserPerDay}
                  onChange={(e) => actions.setValue(EVOUCHER, { maxVoucherQuantityPerUserPerDay: e.target.value })}/>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col md={6}>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Voucher Version</ControlLabel>
              </Col>
              <Col md={7}>
                <Select
                  disabled={isEVoucherPublished}
                  placeholder="Select voucher version"
                  options={[
                    {
                      label: "Version 1",
                      value: 1
                    },
                    {
                      label: "Version 2",
                      value: 2
                    }
                  ]}
                  value={version}
                  onChange={(value) => {
                    let stateToUpdate = {
                      version: value
                    };

                    if (
                      !IS_VALID(value) ||
                      (
                        IS_VALID(value) &&
                        value.value !== 1
                      )
                    ) {
                      stateToUpdate.earningPeriod = null;
                      stateToUpdate.earningPeriodStartDate = "";
                      stateToUpdate.earningPeriodEndDate = "";
                    }

                    if (
                      !IS_VALID(value) ||
                      (
                        IS_VALID(value) &&
                        value.value !== 2
                      )
                    ) {
                      stateToUpdate.campaignCategory = null;
                    }

                    actions.setValue(EVOUCHER, stateToUpdate);
                  }}
                />
              </Col>
            </Row>
            <Row style={space}>
              <Col md={12}>
                <Button
                  style={{ width: "100%" }}
                  disabled={!IS_VALID(version) || (IS_VALID(version) && version.value === 1)}
                  onClick={() => {this.setState({ showModalCategory: true })}}
                  >
                  <b>Select Campaign Category</b>
                </Button>
              </Col>
            </Row>
          </Col>
          <Col
            md={6}
            style={!IS_VALID(version) || (IS_VALID(version) && version.value === 1) ? { opacity: "0.65"} : null}
          >
            <Row>
              <Col
                md={12}
                style={{ textAlign: "center" }}
              >
                <ControlLabel>Campaign Category</ControlLabel>
              </Col>
            </Row>
            <Row style={{ paddingTop: "10px" }}>
              <Col md={4}>
                <ControlLabel>Title</ControlLabel>
              </Col>
              <Col
              md={8}
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap"
                }}
              >
                {
                  IS_VALID(campaignCategory) &&
                  IS_VALID(campaignCategory.get("title")) ? (
                    campaignCategory.get("title")
                  ) : (
                    ""
                  )
                }
              </Col>
            </Row>
            <Row style={{ paddingTop: "10px" }}>
              <Col md={4}>
                <ControlLabel>Start Date</ControlLabel>
              </Col>
              <Col md={8}>
                {
                  IS_VALID(campaignCategory) &&
                  IS_VALID(campaignCategory.get("campaignStartDate")) ? (
                    moment(campaignCategory.get("campaignStartDate")).format("MMM-DD-YYYY hh:mm:ss A")
                  ) : (
                    ""
                  )
                }
              </Col>
            </Row>
            <Row style={{ paddingTop: "10px" }}>
              <Col md={4}>
                <ControlLabel>End Date</ControlLabel>
              </Col>
              <Col md={8}>
                {
                  IS_VALID(campaignCategory) &&
                  IS_VALID(campaignCategory.get("campaignEndDate")) ? (
                    moment(campaignCategory.get("campaignEndDate")).format("MMM-DD-YYYY hh:mm:ss A")
                  ) : (
                    ""
                  )
                }
              </Col>
            </Row>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col md={6}>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Earning Period {requiredSpan} {!IS_VALID(version) || !(IS_VALID(version) && version.value === 1) ? popupMessage(<i className="fa fa-info-circle"></i>, "Earnng Peiriod is only available for Version 1.") : ""}</ControlLabel>
              </Col>
              <Col md={7}>
                <Select.Async
                  placeholder="Select or Search..."
                  disabled={!IS_VALID(version) || !(IS_VALID(version) && version.value === 1)}
                  loadOptions={(input, cb) => loadOptions(input, cb, "VoucherEarningPeriod", "name")}
                  value={earningPeriod}
                  onChange={(value) => actions.setValue(EVOUCHER, { earningPeriod: value })}/>
              </Col>
            </Row>
            {!IS_NULL(earningPeriod) && earningPeriod.label.toUpperCase() === "DATE RANGE" ? (
              <Row>
                <Col md={12}>
                  <InputGroup>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat={false}
                      value={earningPeriodStartDate}
                      onChange={(datetime) => {
                        actions.setValue(EVOUCHER, { earningPeriodStartDate: datetime })
                      }}
                      inputProps={{
                        placeholder: "Start Date",
                        style: {
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0
                        }
                      }}
                      />
                    <InputGroup.Addon>TO</InputGroup.Addon>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat={false}
                      value={earningPeriodEndDate}
                      onChange={(datetime) => {
                        actions.setValue(EVOUCHER, { earningPeriodEndDate: datetime })
                      }}
                      inputProps={{
                        placeholder: "End Date",
                        style: {
                          position: "initial",
                          borderRadius: "0 4px 4px 0"
                        }
                      }}
                      />
                  </InputGroup>
                </Col>
              </Row>
            ) : (
              ""
            )}
            {isBirthdayVoucher ? (
              [
                <Row style={space}>
                  <Col md={5}>
                    <ControlLabel>Birth Month {requiredSpan}</ControlLabel>
                  </Col>
                  <Col md={7}>
                    <Select
                      disabled={isEVoucherPublished}
                      placeholder="Select Birth Month"
                      options={birthMonthOptions}
                      value={birthMonth}
                      onChange={(value) => {
                        let stateToUpdate = {
                          birthMonth: value
                        };

                        if (IS_VALID(value)) {
                          stateToUpdate.tdd_birthMonthStartDate = moment().month(value.value).startOf("month").add(4, "hours");
                          stateToUpdate.tdd_birthMonthEndDate = moment().month(value.value).endOf("month").add(4, "hours");
                        } else {
                          stateToUpdate.tdd_birthMonthStartDate = "";
                          stateToUpdate.tdd_birthMonthEndDate = "";
                        }

                        actions.setValue(EVOUCHER, stateToUpdate);
                      }}
                      />
                  </Col>
                </Row>,
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <InputGroup>
                        <DateTime
                          dateFormat="MMM DD, YYYY"
                          timeFormat="hh:mm A"
                          value={tdd_birthMonthStartDate}
                          inputProps={{
                            placeholder: "Start Date",
                            disabled: true,
                            style: {
                              position: "initial",
                              borderRadius: "4px 0 0 4px"
                            }
                          }}
                        />
                        <InputGroup.Addon>TO</InputGroup.Addon>
                        <DateTime
                          dateFormat="MMM DD, YYYY"
                          timeFormat="hh:mm A"
                          value={tdd_birthMonthEndDate}
                          inputProps={{
                            disabled: true,
                            placeholder: "End Date",
                            style: {
                              position: "initial",
                              borderRadius: "0 4px 4px 0"
                            }
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              ]
            ) : (
              ""
            )}
            <Row style={space}>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>Campaign Date{totalCampaignDays >= 0 ? ` (${totalCampaignDays} day${totalCampaignDays > 1 ? "s" : ""}) ` : " "}{requiredSpan}</ControlLabel>
                  <InputGroup>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat="hh:mm A"
                      value={campaignStartDate}
                      onChange={(datetime) => {
                        if (!isEVoucherPublished) {
                          actions.setValue(EVOUCHER, { campaignStartDate: datetime });
                        }
                        // disabled: isEVoucherPublished || isBirthdayVoucher
                      }}
                      inputProps={{
                        placeholder: "Start Date",
                        disabled: isEVoucherPublished,
                        style: {
                          position: "initial",
                          borderRadius: "4px 0 0 4px"
                        }
                      }}
                      />
                    {/*
                      <FormControl
                        style={{ lineHeight: "unset" }}
                        type="date"
                        value={campaignStartDate}
                        onChange={(e) => {
                          if (!isEVoucherPublished) {
                            actions.setValue(EVOUCHER, { campaignStartDate: e.target.value });
                          }
                        }}
                        disabled={isEVoucherPublished}
                        />
                      */}
                    <InputGroup.Addon>TO</InputGroup.Addon>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat="hh:mm A"
                      value={campaignEndDate}
                      onChange={(datetime) => {
                        actions.setValue(EVOUCHER, { campaignEndDate: datetime });
                        // disabled: isBirthdayVoucher,
                      }}
                      inputProps={{
                        placeholder: "End Date",
                        style: {
                          position: "initial",
                          borderRadius: "0 4px 4px 0"
                        }
                      }}
                      />
                    {/*
                      <FormControl
                        style={{ position: "initial", lineHeight: "unset" }}
                        type="date"
                        value={campaignEndDate}
                        onChange={(e) => actions.setValue(EVOUCHER, { campaignEndDate: e.target.value })}/>
                      */}
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            {isWelcomeVoucher ? (
              <Row style={space}>
                <Col md={5}>
                  <ControlLabel>Welcome Days {requiredSpan}</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    type="number"
                    value={welcomeDays}
                    onChange={(e) => actions.setValue(EVOUCHER, { welcomeDays: e.target.value })}
                    />
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>
          <Col md={6}>
            <Row style={space}>
              <Col md={5}>
                <ControlLabel>Voucher Validity Type {requiredSpan}</ControlLabel>
              </Col>
              <Col md={7}>
                <Select.Async
                  disabled={isBirthdayVoucher}
                  placeholder="Select or Search..."
                  loadOptions={(input, cb) => loadOptions(input, cb, "VoucherValidityType", "name")}
                  value={voucherValidityType}
                  onChange={(value) => {
                    if (!isBirthdayVoucher) {
                      let stateToUpdate = {
                        voucherValidityType: value
                      };

                      if (!IS_VALID(value) || value.shortName !== "T") {
                        stateToUpdate.voucherValidityHour = "";
                        stateToUpdate.voucherValidityMinute = "";
                        stateToUpdate.voucherValiditySecond = "";
                      }

                      if (!IS_VALID(value) || value.shortName !== "SDT") {
                        stateToUpdate.voucherValidityStartTime = "";
                        stateToUpdate.voucherValidityEndTime = "";
                        stateToUpdate.voucherValidityIsUseCalendarDay = false;
                      }

                      if (!IS_VALID(value) || value.shortName !== "DR") {
                        stateToUpdate.voucherValidityStartDate = "";
                        stateToUpdate.voucherValidityEndDate = "";
                        stateToUpdate.voucherValidityIsUseCalendarDay = false;
                      }

                      if (!IS_VALID(value) || value.shortName !== "DT") {
                        stateToUpdate.voucherValidityDays = "";
                        stateToUpdate.voucherValidityEndTime = "";
                      }

                      actions.setValue(EVOUCHER, stateToUpdate);
                    }
                  }}
                  />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {isBirthdayVoucher ? (
                  <p>Voucher Validity is until end of month</p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            {isVoucherValidityType("DR") ? (
              <Row style={space}>
                <Col md={12}>
                  <ControlLabel
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <span>Voucher Validity Date {requiredSpan}</span>
                    <Checkbox
                      inline
                      checked={voucherValidityIsUseCalendarDay}
                      onChange={(e) => {
                        actions.setValue(EVOUCHER, {
                          voucherValidityIsUseCalendarDay: e.target.checked
                        });
                      }}
                    >
                      Use Calendar Day
                    </Checkbox>
                  </ControlLabel>
                  <InputGroup>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat="hh:mm A"
                      value={voucherValidityStartDate}
                      onChange={(date) => actions.setValue(EVOUCHER, { voucherValidityStartDate: date })}
                      inputProps={{
                        placeholder: "Start Date",
                        style: {
                          borderRadius: "4px 0 0 4px"
                        }
                      }}
                      />
                    <InputGroup.Addon>TO</InputGroup.Addon>
                    <DateTime
                      dateFormat="MMM DD, YYYY"
                      timeFormat="hh:mm A"
                      value={voucherValidityEndDate}
                      onChange={(date) => actions.setValue(EVOUCHER, { voucherValidityEndDate: date })}
                      inputProps={{
                        placeholder: "End Date",
                        style: {
                          position: "initial",
                          borderRadius: "0 4px 4px 0"
                        }
                      }}
                      />
                  </InputGroup>
                </Col>
              </Row>
            ) : (
              ""
            )}
            {isVoucherValidityType("T") ? (
              [
                <Row style={{ paddingBottom: "10px" }}>
                  <Col
                    md={3}
                    mdOffset={5}
                    >
                    <ControlLabel>Hour {requiredSpan}</ControlLabel>
                  </Col>
                  <Col
                    md={4}
                    >
                    <FormControl
                      type="number"
                      min="0"
                      value={voucherValidityHour}
                      onChange={(e) => actions.setValue(EVOUCHER, { voucherValidityHour: e.target.value })}
                      />
                  </Col>
                </Row>,
                <Row style={{ paddingBottom: "10px" }}>
                  <Col
                    md={3}
                    mdOffset={5}
                    >
                    <ControlLabel>Minute {requiredSpan}</ControlLabel>
                  </Col>
                  <Col md={4}>
                    <FormControl
                      type="number"
                      min="0"
                      value={voucherValidityMinute}
                      onChange={(e) => actions.setValue(EVOUCHER, { voucherValidityMinute: e.target.value })}
                      />
                  </Col>
                </Row>,
                <Row>
                  <Col
                    md={3}
                    mdOffset={5}
                    >
                    <ControlLabel>Second {requiredSpan}</ControlLabel>
                  </Col>
                  <Col md={4}>
                    <FormControl
                      type="number"
                      min="0"
                      value={voucherValiditySecond}
                      onChange={(e) => actions.setValue(EVOUCHER, { voucherValiditySecond: e.target.value })}/>
                  </Col>
                </Row>,
                <Row>
                  <Col md={12}>
                    <ControlLabel>
                      Total Voucher Validity: <span style={getTotalVoucherValidityResult.error ? { color: "red" } : null }>{getTotalVoucherValidityResult.message}</span></ControlLabel>
                  </Col>
                </Row>
              ]
            ) : (
              ""
            )}
            {isVoucherValidityType("SDT") ? (
              <Row style={space}>
                <Col md={12}>
                <ControlLabel
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <span>Voucher Validity Time {requiredSpan}</span>
                    <Checkbox
                      inline
                      checked={voucherValidityIsUseCalendarDay}
                      onChange={(e) => {
                        actions.setValue(EVOUCHER, {
                          voucherValidityIsUseCalendarDay: e.target.checked
                        });
                      }}
                    >
                      Use Calendar Day
                    </Checkbox>
                  </ControlLabel>
                  <InputGroup>
                    <DateTime
                      dateFormat={false}
                      timeFormat="hh:mm A"
                      value={voucherValidityStartTime}
                      onChange={(date) => actions.setValue(EVOUCHER, { voucherValidityStartTime: date })}
                      inputProps={{
                        placeholder: "Start Time",
                        style: {
                          borderRadius: "4px 0 0 4px"
                        }
                      }}
                    />
                    <InputGroup.Addon>TO</InputGroup.Addon>
                    <DateTime
                      dateFormat={false}
                      timeFormat="hh:mm A"
                      value={voucherValidityEndTime}
                      onChange={(date) => actions.setValue(EVOUCHER, { voucherValidityEndTime: date })}
                      inputProps={{
                        placeholder: "End Time",
                        style: {
                          position: "initial",
                          borderRadius: "0 4px 4px 0"
                        }
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            ) : (
              ""
            )}
            {isVoucherValidityType("DT") ? (
              [
                <Row style={space}>
                  <Col md={5}>
                    <ControlLabel>Voucher Validity Days {requiredSpan}</ControlLabel>
                  </Col>
                  <Col md={7}>
                    <FormControl
                      type="number"
                      value={voucherValidityDays}
                      onChange={(e) => actions.setValue(EVOUCHER, { voucherValidityDays: e.target.value })}
                    />
                  </Col>
                </Row>,
                 <Row style={space}>
                  <Col md={5}>
                    <ControlLabel>Voucher Validity End Time {requiredSpan}</ControlLabel>
                  </Col>
                  <Col md={7}>
                    <DateTime
                      dateFormat={false}
                      timeFormat="hh:mm A"
                      value={voucherValidityEndTime}
                      onChange={(date) => actions.setValue(EVOUCHER, { voucherValidityEndTime: date })}
                      inputProps={{
                        placeholder: "End Time",
                        style: {
                          position: "initial",
                          borderRadius: "0 4px 4px 0"
                        }
                      }}
                    />
                  </Col>
                </Row>
              ]
            ) : (
              ""
            )}
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col md={IS_VALID(specificUser) && specificUser.length > 10 ? 12 : 6}>
            <FormGroup
              style={{ marginBottom: 0 }}>
              <ControlLabel>
                Specific User&nbsp;
                {isSpecificUserFieldDisabled ? (
                  popupMessage(
                    <i className="fa fa-info-circle"></i>,
                    "Card Type is already assigned."
                  )
                ) : (
                  ""
                )}
                {IS_VALID(specificUser) && specificUser.length > 0 ? (
                  `: Total ${specificUser.length}`
                ) : (
                  ""
                )}
              </ControlLabel>
              {isLoadingRelation ? (
                loadingComponent
              ) : (
                <div>
                  <Select.Async
                    placeholder="Select or Search..."
                    multi={true}
                    disabled={isSpecificUserFieldDisabled}
                    loadOptions={(input, cb) => loadOptions(input, cb, "MemberDetail")}
                    value={specificUser}
                    onChange={(value) => actions.setValue(EVOUCHER, { specificUser: value })}
                    className={style.select}
                    />
                  <br/>
                  <Row>
                    <Col md={IS_VALID(specificUser) && specificUser.length > 10 ? 6 : 12}>
                      <Button
                        style={{ width: "100%" }}
                        disabled={isUploadingCSVFile || isSpecificUserFieldDisabled}
                        onClick={() => {
                          this.dropzoneRef.name = "specificUser";
                          this.dropzoneRef.open();
                        }}>
                        {isUploadingCSVFile ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          <b>UPLOAD SPECIFIC USER CSV</b>
                        )}
                      </Button>
                      <p style={{ margin: "10px 0 0" }}>Note: CSV file must have a "memberId" column</p>
                    </Col>
                  </Row>
                </div>
              )}
            </FormGroup>
          </Col>
          <Col md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 12 : 6}>
            <FormGroup
              style={{ marginBottom: 0 }}>
              <ControlLabel>
                Excluded User&nbsp;
                {IS_VALID(blacklistedUser) && blacklistedUser.length > 0 ? (
                  `: Total ${blacklistedUser.length}`
                ) : (
                  ""
                )}
              </ControlLabel>
              {isLoadingRelation ? (
                loadingComponent
              ) : (
                <div>
                  <Select.Async
                    placeholder="Select or Search..."
                    multi={true}
                    loadOptions={(input, cb) => loadOptions(input, cb, "MemberDetail")}
                    value={blacklistedUser}
                    onChange={(value) => actions.setValue(EVOUCHER, { blacklistedUser: value })}
                    className={style.select}
                    />
                  <br/>
                  <Row>
                    <Col md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 6 : 12}>
                      <Button
                        style={{ width: "100%" }}
                        disabled={isUploadingCSVFileBlacklistedUser}
                        onClick={() => {
                          this.dropzoneRef.name = "blacklistedUser";
                          this.dropzoneRef.open();
                        }}>
                        {isUploadingCSVFileBlacklistedUser ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          <b>UPLOAD EXCLUDED USER CSV</b>
                        )}
                      </Button>
                      <p style={{ margin: "10px 0 0" }}>Note: CSV file must have a "memberId" column</p>
                    </Col>
                  </Row>
                </div>
              )}
            </FormGroup>
            <Dropzone
              accept=".csv, text/csv"
              style={{ display: "none" }}
              multiple={false}
              ref={(ref) => { this.dropzoneRef = ref; }}
              onDropAccepted={(acceptedArray) => {
                uploadSpecificUserCSVFile(acceptedArray[0], this.dropzoneRef.name);
              }}
              />
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col md={6}>
            {/*
            <FormGroup>
              <Row>
                <Col md={5}>
                  <ControlLabel>Voucher Version</ControlLabel>
                </Col>
                <Col md={7}>
                  <Select
                    disabled={isEVoucherPublished}
                    placeholder="Select voucher version"
                    options={[
                      {
                        label: "Version 1",
                        value: 1
                      },
                      {
                        label: "Version 2 - TEST",
                        value: 2
                      }
                    ]}
                    value={version}
                    onChange={(value) => {
                      let stateToUpdate = {
                        version: value
                      };

                      if (
                        !IS_VALID(value) ||
                        (
                          IS_VALID(value) &&
                          value.value === 1
                        )
                      ) {
                        stateToUpdate.earningPeriod = null;
                        stateToUpdate.earningPeriodStartDate = "";
                        stateToUpdate.earningPeriodEndDate = "";
                      }

                      actions.setValue(EVOUCHER, stateToUpdate);
                    }}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Campaign Category {requiredSpan}</ControlLabel>
              <Select.Async
                  disabled={!IS_VALID(version) || (IS_VALID(version) && version.value === 1)}
                  placeholder="Select or Search..."
                  loadOptions={(input, cb) => loadOptions(input, cb, "CampaignCategory", "title")}
                  value={campaignCategory}
                  onChange={(value) => actions.setValue(EVOUCHER, { campaignCategory: value })}
                />
            </FormGroup>
            */}
            <FormGroup>
              <ControlLabel>Title {requiredSpan}</ControlLabel>
              <FormControl
                type="text"
                placeholder="Enter Title..."
                value={title}
                onChange={(e) => actions.setValue(EVOUCHER, { title: e.target.value })}
                />
            </FormGroup>
            <FormGroup>
              <ControlLabel style={{ display: 'flex', justifyContent: 'space-between'}}>Promotion Name <span>{promotionName.length}/40</span></ControlLabel>
              <FormControl
                type="text"
                placeholder="Enter Promotion Name..."
                value={promotionName}
                onChange={(e) => {
                  let value = e.target.value;

                  if (value.length <= 40) {
                    actions.setValue(EVOUCHER, { promotionName: value })
                  }
                }}
                />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Description {requiredSpan}</ControlLabel>
              <FormControl
                componentClass="textarea"
                placeholder="Enter Description..."
                value={descriptions}
                onChange={(e) => actions.setValue(EVOUCHER, { descriptions: e.target.value })}
                />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Where to Redeem {requiredSpan}</ControlLabel>
              <FormControl
                componentClass="textarea"
                placeholder="Enter where to redeem..."
                value={whereToRedeem}
                onChange={(e) => actions.setValue(EVOUCHER, { whereToRedeem: e.target.value })}
                />
            </FormGroup>
            <FormGroup>
              <ControlLabel>EV Scanner User {requiredSpan}</ControlLabel>
              {isLoadingRelation ? (
                loadingComponent
              ) : (
                <div>
                  <Select.Async
                    multi={true}
                    placeholder="Select or Search..."
                    loadOptions={(input, cb) => loadOptions(input, cb, "User", "name")}
                    value={evScannerUser}
                    onChange={(value) => actions.setValue(EVOUCHER, { evScannerUser: value })}
                    className={style.select}
                    />
                  <br/>
                  <Row>
                    <Col md={12}>
                      <Button
                        style={{ width: "100%" }}
                        disabled={isUploadingCSVFileEVScannerUser}
                        onClick={() => {
                          this.dropzoneRef.name = "evScannerUser";
                          this.dropzoneRef.open();
                        }}>
                        {isUploadingCSVFileEVScannerUser ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          <b>UPLOAD EV SCANNER USER CSV</b>
                        )}
                      </Button>
                      <p style={{ margin: "10px 0 0" }}>Note: CSV file must have a "username" column</p>
                    </Col>
                  </Row>
                </div>
              )}
            </FormGroup>
            {/*
              <FormGroup>
                <ControlLabel>Manual Dispense</ControlLabel>
                <FormControl
                  type="text"
                  value={manualDispense}
                  onChange={(e) => actions.setValue(EVOUCHER, { manualDispense: e.target.value })}
                  />
              </FormGroup>
              */}
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Serial Number Prefix {requiredSpan}</ControlLabel>
                  <FormControl
                    type="text"
                    maxLength="3"
                    value={serialNumberPrefix}
                    onChange={(e) => {
                      if (!isEVoucherPublished) {
                        actions.setValue(EVOUCHER, { serialNumberPrefix: e.target.value.toUpperCase() })
                      }
                    }}
                    disabled={isEVoucherPublished}
                    />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Budget Amount {requiredSpan}</ControlLabel>
                  <FormControl
                    type="number"
                    value={amount}
                    onChange={(e) => actions.setValue(EVOUCHER, { amount: e.target.value })}
                    />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Promo Owner Cost Center {requiredSpan}</ControlLabel>
                  <FormControl
                    type="text"
                    placeholder="Enter Promo Owner Cost Center..."
                    value={promoOwnerCostCenter}
                    onChange={(e) => actions.setValue(EVOUCHER, { promoOwnerCostCenter: e.target.value })}
                    />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Promo Category {requiredSpan}</ControlLabel>
                  <Select.Async
                    placeholder="Select or Search..."
                    loadOptions={(input, cb) => loadOptions(input, cb, "VoucherPromoCategory", "name")}
                    value={promoCategory}
                    onChange={(value) => {
                      let stateToUpdate = {
                        promoCategory: value
                      };

                      actions.setValue(EVOUCHER, stateToUpdate);
                    }}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>NNSL Amount</ControlLabel>
                  <FormControl
                    type="text"
                    placeholder="Enter NNSL Amount..."
                    value={nnsl_amount}
                    onChange={(e) => actions.setValue(EVOUCHER, { nnsl_amount: e.target.value })}
                    />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>NNC Amount</ControlLabel>
                  <FormControl
                    type="text"
                    placeholder="Enter NNC Amount..."
                    value={nnc_amount}
                    onChange={(e) => actions.setValue(EVOUCHER, { nnc_amount: e.target.value })}
                    />
                </FormGroup>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <FormGroup style={{ position: 'relative' }}>
              <ControlLabel>Image</ControlLabel>
              <div
                style={{
                  position: 'absolute',
  								width: '30px',
  								height: '30px',
  								background: 'red',
  								paddingTop: '4px',
                  top: '15px',
                  right: '-9px',
                  zIndex: 5,
  								textAlign: 'center',
  								borderRadius: '50px',
  								fontWeight: '600',
  								cursor: 'pointer',
                  ...isHideX
                }}
                onClick={() => {
                  actions.setValue(EVOUCHER, { image: null });
                }}
                >
                x
              </div>
              <Dropzone
                style={{
                  position: "",
                  width: "100%",
  								height: "300px",
  								border: "1px solid #e1e1e1",
  								borderRadius: "0px",
  								backgroundColor: "#f5f5f5",
                  ...dropZoneStyle
                }}
                accept="image/*"
                multiple={false}
                onDropAccepted={(acceptedArray) => {
                  actions.setValue(EVOUCHER, { image: acceptedArray[0] });
                }}
                >
                <img
                  style={imageStyle}
                  src={imageSrc}
                  />
              </Dropzone>
            </FormGroup>
            <FormGroup>
              <Checkbox
                inline={true}
                disabled={!isWelcomeVoucher}
                checked={isShowForFirstTimeUsers}
                onChange={(e) => {
                  if (isWelcomeVoucher) {
                    actions.setValue(EVOUCHER, { isShowForFirstTimeUsers: e.target.checked })
                  }
                }}
                >
                <b>Show for First time Users (for Welcome Voucher Only)</b>
              </Checkbox>
            </FormGroup>
            <FormGroup>
              <Checkbox
                inline={true}
                checked={isShowRemainingQuantity}
                onChange={(e) => {
                  actions.setValue(EVOUCHER, { isShowRemainingQuantity: e.target.checked });
                }}
                >
                <b>Show Remaining Quantity</b>
              </Checkbox>
            </FormGroup>
            <FormGroup>
              <Checkbox
                inline={true}
                checked={isRateRequired}
                onChange={(e) => {
                  let stateToUpdate = {
                    isRateRequired: e.target.checked
                  };

                  if (!e.target.checked) {
                    stateToUpdate.rateTimeConfigHour = "";
                    stateToUpdate.rateTimeConfigMinute = "";
                    stateToUpdate.rateTimeConfigSecond = "";
                  }

                  actions.setValue(EVOUCHER, stateToUpdate);
                }}
                >
                <b>Show Rate form after redeem</b>
              </Checkbox>
              {isRateRequired ? (
                <FormGroup
                  style={{
                    paddingLeft: "20px"
                  }}
                  >
                  <Row style={{ paddingBottom: "10px" }}>
                    <Col
                      md={3}
                      >
                      <ControlLabel>Hour {requiredSpan}</ControlLabel>
                    </Col>
                    <Col
                      md={4}
                      >
                      <FormControl
                        type="number"
                        min="0"
                        value={rateTimeConfigHour}
                        onChange={(e) => actions.setValue(EVOUCHER, { rateTimeConfigHour: e.target.value })}
                        />
                    </Col>
                  </Row>
                  <Row style={{ paddingBottom: "10px" }}>
                    <Col
                      md={3}
                      >
                      <ControlLabel>Minute {requiredSpan}</ControlLabel>
                    </Col>
                    <Col
                      md={4}
                      >
                      <FormControl
                        type="number"
                        min="0"
                        value={rateTimeConfigMinute}
                        onChange={(e) => actions.setValue(EVOUCHER, { rateTimeConfigMinute: e.target.value })}
                        />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      >
                      <ControlLabel>Second {requiredSpan}</ControlLabel>
                    </Col>
                    <Col
                      md={4}
                      >
                      <FormControl
                        type="number"
                        min="0"
                        value={rateTimeConfigSecond}
                        onChange={(e) => actions.setValue(EVOUCHER, { rateTimeConfigSecond: e.target.value })}
                        />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <ControlLabel>
                        Total Time before Rate form show: <span style={getTotalRateConfigTimeResult.error ? { color: "red" } : null }>{getTotalRateConfigTimeResult.message}</span>
                      </ControlLabel>
                    </Col>
                  </Row>
                </FormGroup>
              ) : (
                ""
              )}
            </FormGroup>
            <FormGroup>
              <Checkbox
                inline={true}
                checked={isShowMerchantsOwnRedemptionOnly}
                onChange={(e) => {
                  actions.setValue(EVOUCHER, {
                    isShowMerchantsOwnRedemptionOnly: e.target.checked
                  });
                }}
              >
                <b>Show Merchant's own redemption only</b>
              </Checkbox>
            </FormGroup>
          </Col>
        </Row>
        <Modal
          show={showModalCategory}
          backdrop="static"
          onHide={() => {
            this.setState({ showModalCategory: false });
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Campaign Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CampaignCategoryForm
              ref={(ref) => {
                this.campaignCategoryComponentRef = ref;
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="primary"
              onClick={() => {
                if (
                  this.campaignCategoryComponentRef &&
                  this.campaignCategoryComponentRef.getSelectedCampaignCategory
                ) {
                  let campaignCategory = this.campaignCategoryComponentRef.getSelectedCampaignCategory();

                  if (campaignCategory === null) {
                    toast.error("Please select a Campaign Category");
                  } else {
                    actions.setValue(EVOUCHER, { campaignCategory: campaignCategory });

                    this.setState({ showModalCategory: false });
                  }
                }
              }}
            >
              SELECT
            </Button>
            <Button
              onClick={() => {
                this.setState({ showModalCategory: false });
              }}
            >
              CLOSE
            </Button>
          </Modal.Footer>
        </Modal>
      </form>
    );
  }

  componentDidMount () {
    this.getRelation();

    const {
      formType,

      checkEVoucherStatus
    } = this.props;

    if (formType === 'UPDATE') {
      checkEVoucherStatus();
    }
  }
}

class CampaignCategoryForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      search: "",
      selectedCampaignCategory: "",
      campaignCategoryList: [],
      isLoading: false,
      page: 1,
      total: 0
    };

    this.getCampaignCategoryList = this.getCampaignCategoryList.bind(this);
    this.getSelectedCampaignCategory = this.getSelectedCampaignCategory.bind(this);

    this.getCampaignCategoryListDelayCallback = debounce(this.getCampaignCategoryList, 1000);
  }

  getCampaignCategoryList (page = 1) {
    let {
      search
    } = this.state;

    this.setState({
      selectedCampaignCategory: "",
      isLoading: true,
      page
    });

    let campaignCategoryQuery = new Parse.Query("CampaignCategory");

    if (
      search !== "" &&
      search.trim() !== ""
    ) {
      campaignCategoryQuery.matches("title", search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), "i");
    }
    
    campaignCategoryQuery
    .skip((page - 1) * 10)
    .limit(10)
    .select(
      "title",
      "status",
      "campaignStartDate",
      "campaignEndDate"
    )
    .descending("createdAt");

    let countQuery = cloneDeep(campaignCategoryQuery);

    countQuery
    .skip(0)
    .limit(-1);
    
    Promise.all([
      campaignCategoryQuery.find(),
      countQuery.count()
    ])
    .then(([ data, count ]) => {
      this.setState({
        isLoading: false,
        campaignCategoryList: data,
        total: count
      });
    })
    .catch((err) => {
      this.setState({
        isLoading: false,
        campaignCategoryList: [],
        total: 0
      });
    });
  }

  getSelectedCampaignCategory () {
    let {
      selectedCampaignCategory,
      campaignCategoryList,
      isLoading
    } = this.state;

    if (isLoading) {
      return null;
    } else if (selectedCampaignCategory === "") {
      return null;
    } else if ( !IS_VALID(campaignCategoryList[selectedCampaignCategory])) {
      return null;
    }
    
    return campaignCategoryList[selectedCampaignCategory];
  }

  render () {
    let {
      search,
      selectedCampaignCategory,
      campaignCategoryList,
      isLoading,
      page,
      total
    } = this.state;
    
    let tr = [];

    if (isLoading) {
      tr = (
        <tr>
          <td
            colSpan={15}
            style={{
              textAlign: 'center',
              color: '#808080'
            }}
            >
            <i className="fa fa-spinner fa-spin fa-3x"></i>
          </td>
        </tr>
      );
    } else if (campaignCategoryList.length === 0) {
      tr = (
        <tr>
          <td
            colSpan={15}
            style={{
              textAlign: 'center',
              color: '#808080'}}
            >
            No Data Available
          </td>
        </tr>
      );
    } else {
      let renderStatus = (value) => {
        let renderValue = value;

        if (IS_VALID(value)) {
          switch (value.toUpperCase()) {
            case "PUBLISH":
              renderValue = <span style={{ color: "green" }}>{value}</span>;
              break;
            case "EXPIRED":
              renderValue = <span style={{ color: "red" }}>{value}</span>
              break;
            case "DRAFT":
              renderValue = <span style={{ color: "gray" }}>{value}</span>
              break;
          }
        }

        return renderValue;
      };

      tr = campaignCategoryList.map((item, index) => {
        return (
          <tr>
            <td>
              <Radio
                style={{ margin: "0" }}
                checked={selectedCampaignCategory === index}
                onChange={(e) => {
                  this.setState({ selectedCampaignCategory: index });
                }}
              />
            </td>
            <td>{item.get("title")}</td>
            <td>{renderStatus(item.get("status"))}</td>
            <td style={{ whiteSpace: "nowrap" }}>{moment(item.get("campaignStartDate")).format("MMM-DD-YYYY hh:mm:ss A")}</td>
            <td style={{ whiteSpace: "nowrap" }}>{moment(item.get("campaignEndDate")).format("MMM-DD-YYYY hh:mm:ss A")}</td>
          </tr>
        );
      })
    }

    return (
      <div>
        <FormControl
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => {
            this.setState({ search: e.target.value });
            this.getCampaignCategoryListDelayCallback();
          }}
        />
        <br/>
        <div
          style={{ overflowX: "auto" }}
        >
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th></th>
                <th>Title</th>
                <th>Status</th>
                <th>Campaign Start Date</th>
                <th>Campaign End Date</th>
              </tr>
            </thead>
            <tbody>
              {tr}
            </tbody>
          </Table>
        </div>
        <Pagination
          activePage={page}
          itemsCountPerPage={10}
          totalItemsCount={total}
          pageRangeDisplayed={5}
          onChange={(pageNumber) => {
            this.getCampaignCategoryList(pageNumber);
          }}
        />
      </div>
    );
  }

  componentDidMount () {
    this.getCampaignCategoryList();
  }
}


// WEBPACK FOOTER //
// ./components/EVoucher/FormContainer/Create.js